package xim.poc.game.configuration.v0.tactics

import xim.poc.SceneManager
import xim.poc.game.QueryMenuOption
import xim.poc.game.QueryMenuResponse
import xim.poc.game.UiStateHelper
import xim.poc.game.configuration.*
import xim.poc.ui.ShiftJis
import kotlin.time.Duration.Companion.seconds

class TacticsChallengeUi(val zone: TacticsZoneInstance) {

    companion object {
        fun enterChallenge(zone: TacticsZoneInstance, challenge: TacticsChallengeConfig) {
            TacticsLoadSubAreaEvent.preload(challenge.flavorArea)

            EventScriptRunner.runScript(EventScript(listOf(
                FadeOutEvent(0.25.seconds),
                TacticsLoadSubAreaEvent(SceneManager.getCurrentScene(), challenge.flavorArea),
                RunOnceEventItem {
                    UiStateHelper.clear()
                    val match = TacticsMatchInstance(TacticsChallengeMatch(challenge))
                    match.arenaUi.push()
                    zone.setMatch(match)
                },
                FadeInEvent(0.25.seconds),
            )))
        }
    }

    fun push() {
        UiStateHelper.openQueryMode("Which challenge?", getOptions(), visibleOptions = 6, callback = this::handleChoice)
    }

    private fun getOptions(): List<QueryMenuOption> {
        return TacticsChallengeConfigs.getAll().filter { it.isUnlocked() }.map {
            val completed = TacticsState.isChallengeCleared(it.id)
            val completionString = if (completed) { "${ShiftJis.colorGold}${ShiftJis.solidStar}${ShiftJis.colorClear}" } else { "${ShiftJis.emptyStar}" }
            val bonusString = makeBonusString(it)
            val levelString = it.displayLevel.toString().padStart(2, ' ')

                QueryMenuOption("${completionString}Lv.${levelString} ${it.displayName}${bonusString}", it.id)
            } + QueryMenuOption("Cancel", -1)
    }

    private fun handleChoice(queryMenuOption: QueryMenuOption?): QueryMenuResponse {
        if (queryMenuOption == null || queryMenuOption.value < 0) { return QueryMenuResponse.pop }
        val challenge = TacticsChallengeConfigs[queryMenuOption.value]
        enterChallenge(zone, challenge)
        return QueryMenuResponse.noop
    }

    private fun makeBonusString(challengeConfig: TacticsChallengeConfig): String {
        val bonusText = challengeConfig.bonusText ?: return ""

        val color = if (TacticsState.isChallengeCleared(challengeConfig.id)) { ShiftJis.colorGold } else { "" }
        return "${ShiftJis.leftRoundedBracket}${color}${bonusText}${ShiftJis.colorClear}${ShiftJis.rightRoundedBracket}"
    }

}